(() => {
  if (window.merooContactReady) return;
  window.merooContactReady = true;

  function initialize(root = document) {
    root.querySelectorAll('[data-custom-select]').forEach((select) => {
      if (select.dataset.selectReady) return;
      select.dataset.selectReady = 'true';
      const trigger = select.querySelector('[data-select-trigger]');
      const options = Array.from(select.querySelectorAll('[role="option"]'));
      const input = select.querySelector('input[type="hidden"]');
      const display = select.querySelector('[data-select-value]');
      const isOpen = () => select.getAttribute('data-open') === 'true';
      const selectedIndex = () => Math.max(0, options.findIndex((option) => option.getAttribute('aria-selected') === 'true'));
      const close = (restoreFocus = false) => {
        select.setAttribute('data-open', 'false');
        trigger.setAttribute('aria-expanded', 'false');
        if (restoreFocus) trigger.focus();
      };
      const open = (index = selectedIndex()) => {
        select.setAttribute('data-open', 'true');
        trigger.setAttribute('aria-expanded', 'true');
        options[index]?.focus();
      };
      const choose = (option) => {
        input.value = option.dataset.value;
        display.textContent = option.textContent;
        options.forEach((item) => item.setAttribute('aria-selected', String(item === option)));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        close(true);
      };

      trigger.addEventListener('click', () => isOpen() ? close(true) : open());
      trigger.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          open(event.key === 'ArrowUp' ? options.length - 1 : selectedIndex());
        }
      });
      options.forEach((option) => option.addEventListener('click', () => choose(option)));
      select.addEventListener('keydown', (event) => {
        const index = options.indexOf(event.target);
        if (event.key === 'Escape' && isOpen()) {
          event.preventDefault();
          close(true);
        }
        if (index < 0) return;
        if (event.key === 'Tab') {
          // Restore the trigger so normal Tab/Shift+Tab continues through the form.
          close(true);
          return;
        }
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          choose(options[index]);
        } else if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? options.length - 1 :
            (index + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
          options[next].focus();
        } else if (event.key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) {
          const ordered = [...options.slice(index + 1), ...options.slice(0, index + 1)];
          const match = ordered.find((item) => item.textContent.trim().toLowerCase().startsWith(event.key.toLowerCase()));
          if (match) { event.preventDefault(); match.focus(); }
        }
      });
      select.addEventListener('focusout', (event) => {
        if (!select.contains(event.relatedTarget)) close();
      });
      const outside = (event) => { if (!select.contains(event.target)) close(); };
      document.addEventListener('click', outside);
      select.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
        document.removeEventListener('click', outside);
      }, { once: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
